import {toFragment} from '@frontrow/console/src/entities/helpers/routers/query-params'

type FitT = 'max' | 'crop' | 'scale' | 'clip'

export type ImgixSizeParamsT = {
  width?: number | null
  height?: number | null
  fit?: FitT | null
}

export function getUrlWithImgixParams(url: string, sizeParams?: ImgixSizeParamsT | null): string {
  if (sizeParams === null || sizeParams === undefined) {
    return url
  }
  const {width: w, height: h, fit} = sizeParams
  return toFragment(url, {w, h, fit})
}
